import {Component, Input, OnInit} from '@angular/core';
import {BaseModalComponent, UsersQuery} from "common-shared";
import {takeUntil} from "rxjs/operators";
import {ItemLogModel} from "../../models/item-log.model";
import {ManufacturingItemService} from "../../manufacturing-item.service";
import {ClassificatorValueService} from "web-shared";

@Component({
  selector: 'app-edit-item-log-modal',
  templateUrl: './edit-item-log-modal.component.html',
  styles: []
})
export class EditItemLogModalComponent extends BaseModalComponent implements OnInit {
  @Input() log: ItemLogModel;
  @Input() mode: 'add' | 'edit' = 'add';
  @Input() statusCl: string;

  constructor(protected manufacturingItemService: ManufacturingItemService, public classificatorValueService: ClassificatorValueService, public usersQuery: UsersQuery) {
    super();
  }

  ngOnInit(): void {
  }

  save() {
    if(this.mode == 'add'){
      this.manufacturingItemService.addLog(this.log).pipe(takeUntil(this.componentDestroyed)).subscribe(value => {
        this.close(value, 'add');
      });
    } else {
      this.manufacturingItemService.saveLog(this.log).pipe(takeUntil(this.componentDestroyed)).subscribe(value => {
        this.close(value, 'edit');
      });
    }
  }

  remove() {
    this.manufacturingItemService.removeLog(this.log).pipe(takeUntil(this.componentDestroyed)).subscribe(value => {
      this.close(value, 'remove');
    });
  }
}
